<template>
  <div class='map-area' :id='mapId' :type="mapType" style="width: 100%; height: 100%; margin-left: 0px;">
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import baseMap from '@/mixin/BaseMap'
import commonUI from '@/mixin/commonUI'
import mapApi from '@/api/web/MapApi'
import defaultSettings from '@/assets/js/mapOption'

const statItemStore = 'statItemStore'

export default {
  name: 'MapCompare',
  mixins: [baseMap, commonUI],
  components: {
  },

  data: function () {
    return {}
  },
  computed: {
    ...mapGetters(statItemStore, {
      selectedStatItems: 'selectedStatItems',
      statItemYearInfoWindowMaxCount: 'statItemYearInfoWindowMaxCount',
      selectedYearList: 'selectedYearList'
    })
  },

  watch: {
    selectedYearList (val) {
      this.mapView.resizeMap()
    },

    mapStyle (val) {
      // console.log('mapStyle 변경 됨..', val)
    },
  },

  created () {
  },

  mounted: function () {
    // console.log('MapCompare.. mounted..')
    this.showMapStatDataInfoWindow()
  },

  destroyed () {
  },

  methods: {
    // 시도 통계 상세 데이터 보드
    showDetailDataBoard (areaName, areaCd) {
      // eventBus.$emit('showDataBoard', areaName, areaCd)
      // eventBus.$emit('showMapLocationBoard', areaName, areaCd)
    },

    // 전국 시도별 통계 데이터 InfoWindows 표시
    showMapStatDataInfoWindow () {
      const params = []
      for (const mapItemData of this.selectedStatItems) {
        for (const year of mapItemData.years) {
          if (year === this.mapYear) {
            const statItemParam = {
              mapSysNo: mapItemData.mapSysNo,
              mapItmNo: mapItemData.info.mapItmNo,
              years: [year]
            }
            params.push(statItemParam)
          }
        }
      }

      const layerColors = defaultSettings.map.heatColor[this.getHeatMapColor]

      mapApi.searchMapInfoWindow(params).then(resultData => {
        const apInfoWindowDataList = resultData
        let mapLayerColor = ''
        for (const idx in apInfoWindowDataList) {
          const infoData = apInfoWindowDataList[idx]

          for (const layerIdx in this.mapLayerList) {
            const layer = this.mapLayerList[layerIdx]

            if (infoData.sidoId === layer.feature.properties.adm_cd) {
              mapLayerColor = layerColors[Math.floor(idx / 4)]

              layer.setStyle({
                fillColor: mapLayerColor,
                opacity: 1,
                fillOpacity: this.getFillOpacity
              })

              let contentsInfoHTML = ''
              infoData.values.forEach(element => {
                contentsInfoHTML +=
                  '<tr>' +
                  '<td><span>' + element.year + '</span></td>' +
                  '<td>' + element.mapItmNm + '</td>' +
                  '<td>' + element.itmValue + element.unitNm + '</td>' +
                  '</tr>'
              })

              const contents = '' +
                '<table>' +
                '<tbody>' +
                '<tr>' +
                '<th colspan="3">' + infoData.siNm + '</th>' +
                '</tr>' +
                contentsInfoHTML +
                '</tbody>' +
                '</table>'

              const infoWindow = this.getLayerInfoWindow(layer.feature.properties.adm_cd)

              const utmkXY = new window.sop.LatLng(infoData.latitude, infoData.longitude)
              infoWindow.setUTMK([utmkXY.x, utmkXY.y])
              infoWindow.setContent(contents)

              if (this.isMapPopupViewAllType) {
                infoWindow.addTo(this.mapView.myMap)
              }
              break
            }
          }
        }
        this.mapView.setView(this.mapView.center, this.mapView.baseZoom)
      })
    }
  }
}
</script>

<style scoped>
</style>
